import { Router } from '@angular/router';
import { Admin } from '../Model/admin';
import { ServiceAdminService } from '../Providers/service-admin.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';


/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.less'],
})
export class AuthentificationComponent implements OnInit {

  //login et password
  login: string
  password: string;
  // error message
  errorMessage: string;
  errorVisible: boolean = false;

  constructor(private service: ServiceAdminService, private router: Router) { }

  ngOnInit() {
    console.log("---------------------------------------------");
  }

  //=====================================
  //           authentification
  //=====================================

  onSubmit() {
    this.service.authentificate(this.login, this.password).subscribe(_admin => {
      this.service.saveTokenInStorage(_admin.token, true);
      this.router.navigate(['/admin']);
      this.errorVisible = false;
      //window.location.pathname = "/admin";
    }, error => { this.errorVisible = true; this.errorMessage = "this login or password is not correct "; });
  }

}



// WEBPACK FOOTER //
// ./src/app/authentification/authentification.component.ts